import { EncounterSchema } from '../../../services/types/treatment-types';
import { Button } from '../../ui/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from '../../ui/catalyst/dialog';
import { EncounterForm } from './EncounterForm';

interface EncounterDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  currentEncounter?: EncounterSchema;
  initialData?: {
    date: string;
    description: string;
    services: string[];
  };
  onSubmit: () => void;
  submitButtonText: string;
  formPrefix?: string;
  onChange?: (formData: {
    date: string;
    description: string;
    services: string[];
  }) => void;
}

export const EncounterDialog = ({
  isOpen,
  onClose,
  title,
  description,
  currentEncounter,
  initialData,
  onSubmit,
  submitButtonText,
  formPrefix = '',
  onChange,
}: EncounterDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogDescription>{description}</DialogDescription>
      <DialogBody>
        <EncounterForm
          initialData={initialData}
          prefix={formPrefix}
          onChange={onChange}
        />
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="blue" onClick={onSubmit}>
            {submitButtonText}
          </Button>
        </DialogActions>
      </DialogBody>
    </Dialog>
  );
};
